import * as React from 'react'; 

import config from '../../config';
import { useSelector } from 'react-redux';
import { UserContext } from '../providers/UserProvider';
import { ProductCategoryContext } from '../productCategory/ProductCategoryProvider';
import { getCategoryInfoItem } from '../productCategory/category-search-utils';
import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper';
import ShopByProductProvider from './ShopByProductProvider';
import CategorySearchResults from './CategorySearchResults';
import SignUpBar from '../footer/SignUpBar';

import Spinner from '../common/Spinner';
import PropTypes from 'prop-types';

/**
 * Shop by Product - Ordering dispensaries by proximity (or we'll prompt for address).
 * 
 * @param {string} productCategory - via path, set by /shopByproduct
 */
const ShopByProduct = ({
  productCategory='',   /* optional from url */
}) => {

  const { user, location, searchLocation, setSearchLocation } = React.useContext(UserContext);
  const { productCategories, defaultCategory } = React.useContext(ProductCategoryContext);

  const isPickup = useSelector(state => state.is_pickup); 

  const [initialCategory, setInitialCategory] = React.useState();

  React.useEffect(() => {
    if (!initialCategory && productCategories?.length) {
      // Flower => flower
      setInitialCategory(
        productCategory 
          ? getCategoryInfoItem(productCategory, 'name', productCategories)
          : defaultCategory.name /* sorted by priority */
      );
    }
  }, [initialCategory, defaultCategory, productCategories, productCategory]); 

  // FOR CYPRESS TEST ONLY
  const [hashChecked, setHashChecked] = React.useState();
  React.useEffect(() => {
    if (config.IS_DEV && !hashChecked) {
      if(window.location.hash === '#cyTest') {
        const address = {
          street_address: "2500 Massachusetts Avenue",
          city: "Cambridge",
          state: "MA",
          zip_code: "02140"
        };
        setHashChecked(true);
        setSearchLocation(address);
      }
    }
  }, [hashChecked, setSearchLocation]);

  return (
    <>
      <BodyWrapper pageLayout={LayoutTypes.Narrow}>
        { initialCategory
          ? <ShopByProductProvider 
              initialCategory={initialCategory}
              userAddress={user?.isAnonynous ? searchLocation : location}
              isPickup={isPickup}>
              <CategorySearchResults productCategory={initialCategory} />
            </ShopByProductProvider>
          : <Spinner />
        }

        { !config.IS_PREVIEW_MODE &&     
          <SignUpBar />
        }
      </BodyWrapper>
    </>
  );
};

ShopByProduct.propTypes = {
  productCategory: PropTypes.string
}

export default ShopByProduct;